export enum DeviceStatus {
    ONLINE_WITH_TRIP = 'ONLINE_WITH_TRIP',
    ONLINE_WITH_TRIP_LOADED = 'ONLINE_WITH_TRIP_LOADED',
    ONLINE_WITHOUT_TRIP = 'ONLINE_WITHOUT_TRIP',
    OFFLINE_WITH_TRIP = 'OFFLINE_WITH_TRIP',
    OFFLINE_WITH_TRIP_LOADED = 'OFFLINE_WITH_TRIP_LOADED',
    OFFLINE_WITHOUT_TRIP = 'OFFLINE_WITHOUT_TRIP',
}
